import type {
  PayPlanTemplate,
  CreateTemplateRequest,
  UpdateTemplateRequest,
} from '@pay-plan/shared';
import { apiRequest } from './client.js';

export async function listTemplates(): Promise<PayPlanTemplate[]> {
  const res = await apiRequest<{ templates: PayPlanTemplate[] }>('GET', '/templates');
  return res.templates;
}

export async function getTemplate(templateId: string, version?: number): Promise<PayPlanTemplate> {
  const path =
    version !== undefined
      ? `/templates/${templateId}/versions/${version}`
      : `/templates/${templateId}`;
  const res = await apiRequest<{ template: PayPlanTemplate }>('GET', path);
  return res.template;
}

export async function listTemplateVersions(templateId: string): Promise<PayPlanTemplate[]> {
  const res = await apiRequest<{ versions: PayPlanTemplate[] }>(
    'GET',
    `/templates/${encodeURIComponent(templateId)}/versions`,
  );
  return res.versions;
}

export async function createTemplate(data: CreateTemplateRequest): Promise<PayPlanTemplate> {
  const res = await apiRequest<{ template: PayPlanTemplate }>('POST', '/templates', data);
  return res.template;
}

export async function updateTemplate(
  templateId: string,
  data: UpdateTemplateRequest,
): Promise<PayPlanTemplate> {
  const res = await apiRequest<{ template: PayPlanTemplate }>(
    'PUT',
    `/templates/${templateId}`,
    data,
  );
  return res.template;
}

export async function getTemplateAssignments(templateId: string): Promise<{ count: number }> {
  return apiRequest<{ count: number }>(
    'GET',
    `/templates/${encodeURIComponent(templateId)}/assignments`,
  );
}

export async function deleteTemplate(
  templateId: string,
  cascade: boolean,
): Promise<{ deleted: boolean; versionsRemoved: number; assignmentsCascaded: number }> {
  return apiRequest('DELETE', `/templates/${encodeURIComponent(templateId)}?cascade=${cascade}`);
}
